<template>
	<div class="forgot-password">

		<div class="container">
      <h3>{{ message }}</h3>
		</div>

    <crowd-or-rais></crowd-or-rais>
	</div>
</template>

<script>
// API
import auth from '@/api/v1/auth/authService';
// Components
import Alert from '@/components/Alert';
import CrowdOrRais from '@/components/CrowdOrRais';

export default {
  components: { Alert, CrowdOrRais },
  data() {
    return {
      message: '',
    };
  },
  methods: {
    clearAlerts() {
      this.success = '';
      this.errors = {};
    },
  },
  created() {
    auth.confirmAccount({ token: this.$route.query.token }).then((response) => {
      this.message = response.data.message;
    }).catch((response) => {
      this.message = response.response.data.errors[0];
    });
  },
};
</script>



// WEBPACK FOOTER //
// ConfirmAccount.vue?611137cd